import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Icon } from "@iconify/react";

gsap.registerPlugin(ScrollTrigger);

const projects = [
    {
        id: "01",
        title: "ISO Mitra",
        img: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1771653777_bf234434ff9e539e4ee7.png",
    },
    {
        id: "02",
        title: "Cert Mitra",
        img: "https://api.visko.group/public/assets/img/uploads/gallery/cert-mitralogo.png",
    },
    {
        id: "03",
        title: "Remark HR (India)",
        img: "https://api.visko.group/public/assets/img/uploads/gallery/Frame%20170748139.webp",
        highlight: true,
    },
    {
        id: "04",
        title: "Remark HR (UAE)",
        img: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1771656440_557748d98fa2d66d8ffd.jpg",
    },
    // {
    //     id: "05",
    //     title: "Nature Branding",
    //     img: "https://demo.casethemes.net/mouno/wp-content/uploads/2025/02/post-23-767x642.webp",
    // },
];

export default function PortfolioSection() {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);
    const titleRef = useRef([])

    useEffect(() => {
        const ctx = gsap.context(() => {
            cardRefs.current.forEach((card, index) => {
                gsap.from(card, {
                    y: 80,
                    opacity: 0,
                    duration: 1,
                    delay: index * 0.1,
                    scrollTrigger: {
                        trigger: card,
                        start: "top 100%",
                    },
                    ease: "power3.out",
                });
            });
            gsap.from(titleRef.current, {
                opacity: 0,
                x: 80,
                duration: 0.9,
                ease: "power3.out",
            });
        }, sectionRef);

        return () => ctx.revert();
    }, []);

    // ---- Image Parallax + Zoom effect ----
    useEffect(() => {
        cardRefs.current.forEach((card) => {
            const img = card.querySelector("img");
            if (!img) return;

            card.addEventListener("mousemove", (e) => {
                const rect = card.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;
                const moveX = (x / rect.width - 0.5) * 20;
                const moveY = (y / rect.height - 0.5) * 20;
                gsap.to(img, {
                    scale: 1.1,
                    x: moveX,
                    y: moveY,
                    duration: 0.4,
                    ease: "power3.out",
                });
            });


            card.addEventListener("mouseleave", () => {
                gsap.to(img, {
                    scale: 1,
                    x: 0,
                    y: 0,
                    duration: 0.6,
                    ease: "power3.out",
                });
            });
        });
    }, []);

    return (
        <section
            ref={sectionRef}
            className="bg-black text-white md:py-28 py-0 px-4 md:px-10 lg:px-20 "
        >
            <div className="text-center mb-12" ref={titleRef}>
                <div className="flex justify-center mb-6">

                    <button className="bg-white/10 border border-white/20 px-5 py-2 rounded-full text-sm hover:bg-white/20 transition-all flex">
                        <Icon
                            icon="material-symbols:lightbulb-2-rounded"
                            className="mr-1.5 text-[#F26A33] drop-shadow-[0_0_6px_#F26A33]"
                            width="22"
                            height="20"
                        />
                        {/* BEST PROJECT PORTFOLIO */}
                        OUR TOP PROJECTS
                    </button>
                </div>

                {/* Heading */}
                <h2 className="animate-text text-4xl lg:text-4xl xl:text-7xl font-light text-gray-400 md:mb-4 leading-tight">
                    {/* Digital Branding */}
                    Best Digital{" "}
                    <span className="text-white font-light">
                        {/* Services Aligned  */}
                        Solutions Delivered
                    </span>
                </h2>
                <h2 className="animate-text text-4xl lg:text-4xl xl:text-7xl font-light text-white leading-tight mb-4">
                    {/* With Your Goals */}
                    For Better Growth
                </h2>
            </div>

            <div className="max-w-screen-2xl mx-auto font-[Poppins]">
                <div className="flex flex-col gap-6">
                    {projects.map((project, index) => (
                        <div
                            key={index}
                            ref={(el) => (cardRefs.current[index] = el)}
                            className={`relative flex flex-col md:flex-row justify-between items-center rounded-[3rem] transition-all duration-500 overflow-hidden border border-gray-700 ${project.highlight
                                ? "bg-gradient-to-r from-[#407E96] to-[#F26A33] p-6 h-auto md:h-96 md:p-10"
                                : "bg-[#0f0f0f] hover:bg-[#1a1a1a] hover:bg-gradient-to-r from-[#407E96] to-[#F26A33] p-5 md:p-8 rounded-full"
                                } ${index % 2 !== 0 ? "md:flex-row-reverse md:ml-24 lg:ml-48" : "md:mr-24 lg:mr-48"}`}
                        >
                            <div
                                className={`flex flex-col justify-center gap-5 px-8 ${project.highlight
                                    ? "items-start text-left md:w-1/2"
                                    : "md:flex-row md:items-center col-span-2"
                                    }`}
                            >
                                <span
                                    className={`text-gray-400 text-2xl sm:text-3xl md:text-5xl font-semibold -mt-2 md:-mt-12 ${project.highlight ? "text-white" : ""
                                        }`}
                                >
                                    {project.id}
                                </span>
                                <h3
                                    className={`text-xl sm:text-2xl md:text-5xl font-bold uppercase ${project.highlight ? "text-white" : "text-gray-100"
                                        }`}
                                >
                                    {project.title}
                                </h3>

                                {project.highlight && (
                                    <>
                                        <p className="text-white/80 text-sm md:text-base max-w-md leading-relaxed">
                                            A modern Indian job portal designed to connect talented professionals across India with top employers. Remark HR simplifies hiring with intelligent matching, seamless applications, and real-time updates for a smarter and more efficient recruitment experience.                                        </p>

                                        {/* <button className="flex items-center justify-center md:justify-start gap-2 bg-white text-black px-6 py-3 rounded-full text-sm font-semibold hover:scale-105 transition mt-2">
                                            View Project Details
                                            <Icon
                                                icon="iconamoon:arrow-up-right-2-duotone"
                                                width="20"
                                            />
                                        </button> */}
                                    </>
                                )}
                            </div>

                            <div className="flex items-center gap-4 mt-4 md:mt-0 ">
                                {/* flex items-center justify-center w-full md:w-1/2 mt-4 md:mt-0 */}
                                <img
                                    src={project.img}
                                    alt={project.title}
                                    className={`rounded-2xl object-cover transition-transform duration-300 ease-out ${project.highlight
                                        ? "w-96 "
                                        : "w-96 h-48 rounded-full"
                                        }`}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}


